import { Box, Button, Image, Text } from '@betty/moonlight';
import { PromoListItemProps } from './PromoListItem.types';
import PromosBadgeList from '../PromosBadgeList/PromosBadgeList';
import { StackNavigationProp, useNavigation } from '@betty/navigation';
import PromoCta from '../PromoCta/PromoCta';
import { memo } from 'react';

function PromoListItem({ promo, ...rest }: PromoListItemProps) {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  return (
    <Box
      backgroundColor="secondaryBackgroundDefault"
      borderRadius="radius-400"
      gap="space-100"
      padding="space-400"
      boxShadow={promo.isOptedIn ? 'rgb(87, 224, 74) 0px 0px 24px 0px' : 'none'}
      {...rest}
    >
      <Box flex={1} gap="space-100">
        <Box position="relative">
          <Image
            source={promo.imageUrl}
            borderRadius="radius-400"
            width="100%"
            aspectRatio={2}
            contentFit="cover"
          />
          {promo.isOptedIn ? (
            <Image
              name="common.check"
              position="absolute"
              top="space-200"
              left="space-200"
              width={25}
              height={25}
            />
          ) : null}
        </Box>
        <Text
          variant="body-l-semi"
          color="darkSurfacePrimary"
          locNS="common"
          marginTop="space-100"
        >
          {promo.title}
        </Text>
        <PromosBadgeList rewards={promo.rewards} />
        <Text
          paddingTop="space-200"
          paddingBottom="space-200"
          variant="body-m-semi"
          color="darkSurfacePrimary"
        >
          {promo.shortDescription}
        </Text>
      </Box>

      <Box paddingTop="space-200" gap="space-300">
        <PromoCta promo={promo} />
        <Button
          variant="secondary"
          locNS="common"
          locKey="learnMore"
          onPress={() =>
            navigation.navigate('PromoDetails', {
              id: promo.slug ?? promo.promotionId,
            })
          }
          alignSelf="center"
          width="100%"
        />
      </Box>
    </Box>
  );
}

export default memo(PromoListItem);
